import { SVGProps, Ref, forwardRef, useId } from 'react';

export const EmojiNeutral3dSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
    const _uniqueId = useId();
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g filter={`url(#${_uniqueId}filter0_i_8745_46)`} suppressHydrationWarning>
                    <path
                        d="M8 .5C1.438.5.5 1.438.5 8s.938 7.5 7.5 7.5 7.5-.937 7.5-7.5S14.563.5 8 .5"
                        fill={`url(#${_uniqueId}paint0_radial_8745_46)`}
                        suppressHydrationWarning
                    />
                </g>
                <path d="M6.987 7.032H4.321v-1.4h2.666z" fill="#79610C" />
                <path d="M8.987 7.032h2.666v-1.4H8.987z" fill="#79610C" />
                <path d="M5.988 12.03h3.999v-1.4h-4z" fill="#79610C" />
            </g>
            <defs>
                <filter
                    id={`${_uniqueId}filter0_i_8745_46`}
                    x={0.5}
                    y={-2}
                    width={17.5}
                    height={17.5}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx={2.5} dy={-2.5} />
                    <feGaussianBlur stdDeviation={2.5} />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_8745_46" />
                </filter>
                <radialGradient
                    id={`${_uniqueId}paint0_radial_8745_46`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(11.211 3.3125) rotate(127.875) scale(13.3614)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
            </defs>
        </svg>
    );
});
EmojiNeutral3dSize16Glyph.displayName = 'EmojiNeutral3dSize16Glyph';
